module.exports = __webpack_public_path__ + "static/media/female.11d6ee13.svg";